import { useState } from 'react'
import SchoolHeader from '../header'
import SchoolSidebar from '../sidebar'
import { Icon1, Icon2, User4, course04 } from '../../imagepath'
import { Link } from 'react-router-dom'
import TeacherServices from "../../../services/TeacherServices";
import { useNavigate } from "react-router-dom";
import {showErrorAlerts,showsuccessAlert} from '../../../services/AlertService';

const AddSchoolTeacher = () => {

    const [isClassAdded, setIsClassAdded] = useState([false]);
    const navigate = useNavigate();
    const toggleClass = (index) => {
      const updatedClasses = [...isClassAdded];
      updatedClasses[index] = !updatedClasses[index];
      setIsClassAdded(updatedClasses);
    };

    const [form, setForm] = useState({ name: '', email: '' });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await TeacherServices.addSchoolTeacher(form.name, form.email);
        console.log(response,'get response');
        if(response && response.message){
          showsuccessAlert(response.message);
            setForm({ name: "", email: "" });
            navigate('/my-teachers');
        }
      } catch (err) {
        // alert("Failure");
      }
  };
    return (
        <>-
            {/* Main Wrapper */}
            <div className="main-wrapper">
                {/* Header */}
                <SchoolHeader activeMenu={"Dashboard"} />
                {/* /Header */}
                {/* Breadcrumb */}
                <div className="breadcrumb-bar breadcrumb-bar-info">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="breadcrumb-list">
                                    <h2 className="breadcrumb-title">Add School Teacher</h2>
                                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/school-dashboard">Home</Link>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Dashboard
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Page Content */}
                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            {/* sidebar */}
                            <SchoolSidebar />
                            {/* /Sidebar */}
                            {/* School Dashboard */}
                            <div className="col-xl-9 col-lg-9">
                                {/* Dashboard Grid */}
                                <div className="row justify-content-center">
                                <form onSubmit={handleSubmit}>
                                <div className="input-block">
                      <label className="form-control-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                      />
                    </div>

                    <div className="d-grid">
                      <button
                        className="btn btn-start"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                                </div>
                            </div>
                            {/* School Dashboard */}
                        </div>
                    </div>
                </div>
                {/* /Page Content */}
                {/* Footer */}

                {/* /Footer */}
            </div>
            {/* /Main Wrapper */}
        </>

    )
}

export default AddSchoolTeacher
